import { useQueryClient } from '@tanstack/react-query';

import { AppIonPage } from '@/core/components/app-ion-page';
import { AppPageContent } from '@/core/components/app-page-content';
import { AppPageLayout } from '@/core/components/app-page-layout';
import { PendingUpgradeBanner } from '@/core/components/billing/pending-upgrade-banner';
import { invalidateDashboardStatusQueries } from '@/core/components/dashboard/dashboard-refresh-keys';
import { DashboardStatusBoard } from '@/core/components/dashboard/dashboard-status-board';
import { PageHeader } from '@/core/components/page-header';
import { useDictionary } from '@/core/providers/dictionary-provider';

export function DashboardPage() {
  const dict = useDictionary();
  const queryClient = useQueryClient();

  return (
    <AppIonPage>
      <AppPageContent
        onRefresh={() => invalidateDashboardStatusQueries(queryClient)}
      >
        <AppPageLayout className="min-w-0 overflow-x-hidden">
          {/* Shell chrome only — the greeting is the page's h1 (DEV-537). */}
          <PageHeader title={dict.dashboard.title} hideTitle />
          <PendingUpgradeBanner />
          <DashboardStatusBoard />
        </AppPageLayout>
      </AppPageContent>
    </AppIonPage>
  );
}
